import axios from 'axios';

const createAxiosInstance = function(baseUrl, accessToken) {
    var headers = {
        'X-Requested-With': 'XMLHttpRequest'
    };
    if (accessToken) {
        headers['Authorization'] = `Bearer ${accessToken}`;
    }
    return axios.create({
        baseURL: baseUrl,
        headers: headers
    });
};




// note: the following commented out code is for integration w/ the identity API
//const siteApi = {
//    changeDateOfBirth(identityApiBaseUri, data, accessToken) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
//        return axiosInstance.put('/api/identity/dateOfBirth?api-version=1.0', data);
//    },
//    changePassword(identityApiBaseUri, data, accessToken) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
//        return axiosInstance.put('/api/identity/password?api-version=1.0', data);
//    },
//    changeUsername(identityApiBaseUri, data, accessToken) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
//        return axiosInstance.put('/api/identity/email?api-version=1.0', data);
//    },
//    preregister(identityApiBaseUri, data) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri);
//        return axiosInstance.post('/api/preregistration?api-version=1.0', data);
//    },
//    register(identityApiBaseUri, data) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri);
//        return axiosInstance.post('/api/identity/register?api-version=1.0', data);
//    },
//    resetPassword(identityApiBaseUri, data) {
//        var axiosInstance = createAxiosInstance(identityApiBaseUri);
//        return axiosInstance.post('/api/identity/password/reset?api-version=1.0', data);
//    }
//};

const siteApi = {
    changeDateOfBirth(identityApiBaseUri, data, accessToken) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
        return axiosInstance.put('/api/identity/dateOfBirth', data);
    },
    changePassword(identityApiBaseUri, data, accessToken) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
        return axiosInstance.put('/api/identity/password', data);
    },
    changeUsername(identityApiBaseUri, data, accessToken) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri, accessToken);
        return axiosInstance.put('/api/identity/email', data);
    },
    preregister(identityApiBaseUri, data) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri);
        return axiosInstance.post('/api/preregistration', data);
    },
    register(identityApiBaseUri, data) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri);
        return axiosInstance.post('/api/identity/register', data);
    },
    resetPassword(identityApiBaseUri, data) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri);
        return axiosInstance.post('/api/identity/password/reset', data);
    },
    resetChangePassword(identityApiBaseUri, data) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri);
        return axiosInstance.post('/api/identity/password/change', data);
    },
    async getClientSettings(identityApiBaseUri) {
        var axiosInstance = createAxiosInstance(identityApiBaseUri);
        return axiosInstance.get('/api/clientSettings');
    }
};

export default (function () {
    return siteApi;
})();